<template>
<router-view></router-view>
</template>

<script>
  import {NOTIFY_SUCCESS, ERROR_MSG} from '../../store/mutation-types'

  export default {
    data () {
      return {
        dropzoneConfig: {}
      }
    },
    created () {
      this.loadPage()
      this.$store.subscribe(function (mutation) {
        if (mutation.payload) {
          switch (mutation.type) {
            case NOTIFY_SUCCESS:
              this.dropzoneConfig.delflag = 1
              break
          }
        }
      }.bind(this))
    },
    computed: {
    },
    methods: {
      loadPage () {
        this.$store.dispatch('getUserDetails', this.$route.query.userid)
        this.$store.dispatch('dropzoneConfig', this.$route.query.userid).then(function () {
          this.dropzoneConfig = this.$store.getters.dropzoneConfig
          if (this.dropzoneConfig.delflag === 1) this.$router.push({name: 'Frozen'})
          else this.$router.push({name: 'Files'})
        }.bind(this))
        .catch(function () {
          this.$store.commit(ERROR_MSG, {
            type: 'error',
            title: this.$t('message.error_popup_page.error'),
            content: this.$t('message.error_popup_page.retry_msg')
          })
        }.bind(this))
      }
    }
  }
</script>
<style>
  .admin-menu a {
    display: block;
    background: #F4EB5F;
    border: 1px solid #EFDB06;
    color: #3D3D3D;
    padding: 10px 15px;
    font-family: 'PT Sans', sans-serif;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 12px;
    transform: scaleX(1);
    transition: transform 200ms ease-in;
  }

  .admin-menu a:hover {
    text-decoration: none;
    transform: scaleX(1.02);
  }

  .admin-new, .admin-products {
    border-bottom: 2px solid #F5F5F5;
    padding: 10px 0;
  }

  .product {
    background: #FFF;
    margin-bottom: 30px;
    position: relative;
    overflow: hidden;
  }

  .product .product__description,
  
  .product__description {
    width: 100%;
    display: flex;
    padding: 20px 20px 15px;
    background: #EFDB06;
  }

  .product__info {
    flex: 2;
  }

</style>



// WEBPACK FOOTER //
// Index.vue?bb61f300